import { gql } from "@edreamsodigeo/frontend-api-client";

export const CATALOGUE_OFFER_FIELDS = gql`
  fragment CatalogueOffer on MembershipOffer {
    membershipOfferId
    plan {
      planName
      membershipTier {
        membershipTierId
        policies {
          autoRenewalPolicy {
            deactivationConditions
          }
          durationPolicy {
            amount
            timeUnit
          }
        }
        valueProposition {
          ... on LimitedMembershipPerk {
            __typename
            type
            usageQuota
          }
          ... on UnlimitedMembershipPerk {
            __typename
            type
          }
        }
        loyaltyRewardsProgram {
          loyaltyRewards
        }
      }
    }
  }
`;

export const SUBSCRIPTION_OFFER_FIELDS = gql`
  fragment SubscriptionOffer on SubscriptionResponse {
    price {
      amount
      currency
    }
    offerId
    renewalPrice {
      amount
      currency
    }
    duration {
      amount
      timeUnit
    }
    renewalDuration {
      amount
      timeUnit
    }
    subscriptionPeriod
    type
  }
`;

export const GET_MEMBERSHIP_SUBSCRIPTION_OFFER_BY_ID = gql`
  ${SUBSCRIPTION_OFFER_FIELDS}
  ${CATALOGUE_OFFER_FIELDS}
  query SubscriptionOffer($offerId: String!) {
    subscriptionOfferById(offerId: $offerId) {
      ...SubscriptionOffer
      catalogueOffer {
        ...CatalogueOffer
      }
    }
  }
`;

export const GET_MEMBERSHIP_SUBSCRIPTION_OFFERS = gql`
  ${SUBSCRIPTION_OFFER_FIELDS}
  ${CATALOGUE_OFFER_FIELDS}
  query SubscriptionOffers @ignore_update {
    subscriptionOffers {
      ...SubscriptionOffer
      catalogueOffer {
        ...CatalogueOffer
      }
    }
  }
`;
